import { uploadService } from '@/apis/upload.s';
import axios from 'axios';
import imageHelpers from '@/helpers/image';

function objectId() {
  return hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => hex(Math.random() * 16));
}
function hex(value) {
  return Math.floor(value).toString(16);
}

export function uploadAdapter(loader) {
  return {
    upload: () => {
      return new Promise((resolve, reject) => {
        loader.file.then(file => {
          (async () => {
            try {
              let inputTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
              let typeIdx = inputTypes.indexOf(file.type);
              let extType = inputTypes[typeIdx];
              let ext = extType.replace('image/', '');
              let type = file.name ? file.name.split('.')[file.name.split('.').length - 1] : ext;
              let id = objectId();
              let urlData = await uploadService.get({ filename: `image-${id}.${type}` });
              console.log('urlData -> ', urlData);
              if (urlData) {
                const resPut = await axios.put(urlData.data.presignedUrl, file, {
                  headers: {
                    'Content-Type': `${file.type}`,
                  },
                });
                console.log('resPut -> ', resPut);
                // let obj = {
                //   alt: file.name,
                //   alt_text: file.name,
                //   src: urlData.data.imagePath,
                //   _id: id,
                //   size: size,
                // };
                // return obj;
                resolve({
                  default: `${imageHelpers.url(urlData.data.imagePath, { width: 1000, height: 1000 })}`,
                });
              }
            } catch (e) {
              console.error(e);
              reject(e);
            }
          })();
        });
      });
    },
  };
}

export function ckuploadPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = loader => {
    return uploadAdapter(loader);
  };
}

export const ckeditorConfig = {
  toolbar: {
    items: [
      'heading',
      'fontFamily',
      'fontColor',
      'fontBackgroundColor',
      'fontSize',
      '|',
      'bold',
      'strikethrough',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'removeFormat',
      '|',
      'outdent',
      'indent',
      'alignment', // Đã có sẵn
      '|',
      'imageInsert',
      'insertTable',
      'htmlEmbed',
      'mediaEmbed',
      'blockQuote',
      'sourceEditing',
      'undo',
      'redo',
    ],
  },
  language: 'en',
  alignment: {
    options: [
      { name: 'left', className: 'text-left', title: 'Align left' },
      { name: 'center', className: 'text-center', title: 'Align center' },
      { name: 'right', className: 'text-right', title: 'Align right' },
      { name: 'justify', className: 'text-justify', title: 'Justify' },
    ],
  },
  image: {
    toolbar: [
      'resizeImage',
      'imageTextAlternative',
      'toggleImageCaption',
      'imageStyle:alignBlockLeft',
      'imageStyle:alignCenter',
      'imageStyle:alignBlockRight',
    ],
    styles: {
      options: ['alignBlockLeft', 'alignCenter', 'alignBlockRight'],
    },
    resizeUnit: 'px',
    resizeOptions: [
      {
        name: 'resizeImage:original',
        value: null,
        label: 'Original',
      },
      {
        name: 'resizeImage:custom',
        label: 'Custom',
        value: 'custom',
      },
      {
        name: 'resizeImage:100',
        value: '100px',
        label: '100px',
      },
      {
        name: 'resizeImage:200',
        value: '200px',
        label: '200px',
      },
    ],
  },
  table: {
    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties'],
  },
  htmlSupport: {
    allow: [
      {
        name: /^.*$/,
        styles: true,
        attributes: true,
        classes: true,
      },
    ],
  },
  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: 'https://',
    decorators: {
      toggleDownloadable: {
        mode: 'manual',
        label: 'Downloadable',
        attributes: {
          download: 'file',
        },
      },
    },
  },
  fontFamily: {
    supportAllValues: true,
  },
  fontSize: {
    options: [
      10,
      11,
      12,
      13,
      14,
      16,
      18,
      20,
      22,
      24,
      28,
      30,
      32,
      34,
      36,
      38,
      40,
      42,
      44,
      46,
      48,
      50,
      52,
      54,
      56,
      58,
      64,
      72,
      84,
      92,
    ],
    supportAllValues: true,
  },
  extraPlugins: [ckuploadPlugin],
};

export const ckeditorConfigFullToolbar = {
  extraPlugins: [ckuploadPlugin],
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h1', title: 'H1', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h2', title: 'H2', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h3', title: 'H3', class: 'ck-heading_heading3' },
      { model: 'heading4', view: 'h4', title: 'H4', class: 'ck-heading_heading4' },
    ],
  },
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      'strikethrough',
      'link',
      'bulletedList',
      'numberedList',
      'blockQuote',
      'insertTable',
      'imageInsert',
      // 'imageUpload',
      'mediaEmbed',
      'undo',
      'redo',
      'alignment',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      '|',
      'removeFormat',
      'sourceEditing',
    ],
    shouldNotGroupWhenFull: true,
  },
  image: {
    toolbar: [
      'imageTextAlternative',
      'imageStyle:full',
      'imageStyle:side',
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
    ],
  },
  table: {
    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableCellProperties'],
    defaultHeadings: {
      rows: 1, // Tạo 1 dòng header => TH
      columns: 0,
    },
  },
  fontSize: {
    options: [
      10,
      11,
      12,
      13,
      14,
      16,
      18,
      20,
      22,
      24,
      28,
      30,
      32,
      34,
      36,
      38,
      40,
      42,
      44,
      46,
      48,
      50,
      52,
      54,
      56,
      58,
      64,
      72,
      84,
      92,
    ],
    supportAllValues: true,
  },
  htmlSupport: {
    allow: [
      {
        name: /^.*$/,
        styles: true,
        attributes: true,
        classes: true,
      },
    ],
  },
};
